import { Icon } from '@platform/components';
import { Link } from 'wouter';

type BackToOptionsLinkProps = {
  url: string;
};

export const BackToOptionsLink = (props: BackToOptionsLinkProps) => {
  const { url } = props;
  return (
    <div className='w-full flex justify-center'>
      <Link
        to={url}
        className='flex flex-row justify-center items-center pb-8 md:pb-2 text-sm text-gray-500 font-semibold focus:bg-white active:text-gray-400 hover:bg-white gap-1 w-[180px] max-w-[180px]'
      >
        <Icon type='arrow-left' size='20' />
        Back to options
      </Link>
    </div>
  );
};
